import { nanoid } from "nanoid";
import { track } from "./facebookPixel";
import { trackInitiateCheckoutEvent } from "./googleTagManager";

const toUrl = (value: string): URL => new URL(value, window.location.origin);

// Track the checkout initiation
// Currently only integrates with Facebook Pixel, but could be extended to other platforms.
export const navigateWithInitiateCheckout = (targetUrl: string) => {
  const url = toUrl(targetUrl);

  const eventID = nanoid();

  try {
    track("InitiateCheckout", undefined, { eventID });
  } catch (error) {
    console.warn("Error tracking checkout initiation with Meta Pixel:", error);
  }

  try {
    trackInitiateCheckoutEvent({ event_id: eventID });
  } catch (error) {
    console.warn("Error tracking checkout initiation with Google Analytics:", error);
  }

  url.searchParams.set("fb_event_id", eventID);

  window.location.href = url.toString();
};
